import __request__ from "routing/request";
export function helloWorld(requestOptions) {
  return __request__("GET", "/", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
